// extracted by mini-css-extract-plugin
export default {"modal":"ModalVacuna_modal__PA3zT","modal-footer":"ModalVacuna_modal-footer__taP+y"};